import { Spinner, Button } from '@enterprise-ui/canvas-ui-react';
import EnterpriseIcon, { SearchIcon, CancelIcon, ChevronUpIcon, ChevronDownIcon } from '@enterprise-ui/icons';
import React from 'react';

var IconArea = function IconArea(_ref) {
  var showSearchIcon = _ref.showSearchIcon,
    isLoading = _ref.isLoading,
    searchText = _ref.searchText,
    isShowingOptions = _ref.isShowingOptions,
    onClear = _ref.onClear,
    disabled = _ref.disabled;
  var iconContent;
  if (isLoading) {
    iconContent = /*#__PURE__*/React.createElement(Spinner, {
      size: "dense"
    });
  } else if ((searchText === null || searchText === void 0 ? void 0 : searchText.length) === 0 && showSearchIcon) {
    iconContent = /*#__PURE__*/React.createElement(EnterpriseIcon, {
      size: "sm",
      icon: SearchIcon,
      className: "C-Autocomplete__IconArea__Icon"
    });
  } else if (!disabled && (searchText === null || searchText === void 0 ? void 0 : searchText.length) !== 0) {
    iconContent = /*#__PURE__*/React.createElement(Button, {
      disabled: disabled,
      type: "ghost",
      iconOnly: true,
      "aria-label": "clear",
      size: "dense",
      onClick: onClear
    }, /*#__PURE__*/React.createElement(EnterpriseIcon, {
      size: "sm",
      icon: CancelIcon
    }));
  } else if (!disabled && isShowingOptions) {
    iconContent = /*#__PURE__*/React.createElement(Button, {
      disabled: disabled,
      type: "ghost",
      iconOnly: true,
      "aria-label": "clear",
      size: "dense",
      onClick: onClear
    }, /*#__PURE__*/React.createElement(EnterpriseIcon, {
      size: "sm",
      icon: ChevronUpIcon
    }));
  } else {
    iconContent = /*#__PURE__*/React.createElement(Button, {
      disabled: disabled,
      type: "ghost",
      iconOnly: true,
      "aria-label": "clear",
      size: "dense",
      onClick: onClear
    }, /*#__PURE__*/React.createElement(EnterpriseIcon, {
      size: "md",
      icon: ChevronDownIcon
    }));
  }
  return /*#__PURE__*/React.createElement("span", {
    className: "C-Autocomplete__IconArea"
  }, iconContent);
};
IconArea.displayName = 'IconArea';

export { IconArea as default };
